import Timer from "./Timer";
import Config from "./Config";
import Logger from "./Logger/Logger";
import EventDispatcher from "./EventDispatcher";
import BrowserController from "./BrowserController";
import Navbar from "./Navbar";

class App
{

    constructor(options) {

        // 1. Start
        this._timer = new Timer();

        // 2. Loading config
        this._config = new Config(this._getDefaultConfig(), options);

        // 3. Creating logger
        /** @type {Logger} */
        this._logger = this.createLogger('APP');
        this._logger.debug('Initializing...');

        // 4. Creating Event dispatcher
        this._eventDispatcher = new EventDispatcher(
            this.createLogger('EVD')
        );

        // 5. Creating Browser controller
        this._browserController = new BrowserController(
            this.createLogger('BRO'),
            this._eventDispatcher,
            window,
            document
        );

        // 6. Loading Navbar controller
        this._navbar = new Navbar(
            this.createLogger('NAV'),
            this._eventDispatcher,
            this._browserController,
            this._config.get('navbar')
        );

        // X. Start
        this._browserController.start();

    }

    _getDefaultConfig()
    {
        return {
            logger: {
                target: 'null', // null|console
                logLevel: 'none' // none|emergency|alert|critical|error|warning|notice|info|debug
            }
        };
    }

    createLogger(name)
    {
        return new Logger(this._timer, name, this._config.get('logger'));
    }


}

export default App;